module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("CONTENTS")])]), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/006_Acknowledgements"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_FM1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chapp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" No One Man")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Time, Place, Influences and Opportunities (1876–1911)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Gresley’s New World (1912–22)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" A Time of Politics and An Age of Science (1922–28)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" A Necessary Distraction (1929–31)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" A Master at Work (1932–34)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Speed, Competition, Art Deco, Aerodynamics and the Science of Publicity (1935)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "box1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" Fete and Fated (1936–41)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_BM1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_BM2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_BM3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Photo Credits")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_5_001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0